import React from 'react';
import PropTypes from 'prop-types';
import {
  TextInput,
  AutocompleteInput,
  SimpleShowLayout,
  FormDataConsumer,
  DisabledInput,
  BooleanInput,
} from 'react-admin';
import Header from '../../../shared/header';
import { countryAlpha2List, getCountryName } from '../../../shared/country';
import { maxLength, nonEmptyString, required } from '../../../core/validators';

export const BusinessAddress = ({ resource, classes, isItaly }) => (
  <SimpleShowLayout resource={resource}>
    <Header label="common.null" />
    <Header label="resources.business.businessAddress" />
    <TextInput
      source="address.streetName"
      validate={[required, maxLength(128)]}
      required
      className={classes.fieldEdit}
      id="Selenium-Business-Edit-Address-StreetName-Input"
    />
    <TextInput
      source="address.postalCode"
      validate={[required, maxLength(32)]}
      required
      className={classes.fieldEdit}
      id="Selenium-Business-Edit-Address-postalCode-Input"
    />
    <TextInput
      source="address.city"
      validate={[required, maxLength(128)]}
      required
      className={classes.fieldEdit}
      id="Selenium-Business-Edit-Address-City-Input"
    />
    <AutocompleteInput
      source="address.countryCode"
      validate={[required, maxLength(2)]}
      choices={countryAlpha2List}
      className={classes.fieldEdit}
      classes={{ suggestionsContainerOpen: classes.autoCompleteContainer }}
      autoComplete="nope"
      options={{ required: true }}
      id="Selenium-Business-Edit-Address-Country-Input"
      label="resources.business.fields.country"
    />
    {isItaly && (
      <TextInput
        source="address.region"
        label="resources.business.fields.mainRegion"
        validate={[required, nonEmptyString, maxLength(64)]}
        className={classes.fieldEdit}
        required
        id="businessMainAddress"
      />
    )}
    <BooleanInput
      source="useAsBillingAddress"
      className={classes.fullWidth}
      id="Selenium-Business-Edit-Address-useAsBillingAddress-Input"
    />
    <FormDataConsumer>
      {({ formData }) =>
        formData.useAsBillingAddress && (
          <React.Fragment>
            <DisabledInput
              resource={resource}
              source="address.streetName"
              validate={[required, maxLength(128)]}
              required
              className={classes.fieldEdit}
              id="Selenium-Business-Edit-Address-useAsBillingAddress-StreetName-Input"
            />
            <DisabledInput
              resource={resource}
              source="address.postalCode"
              validate={[required, maxLength(32)]}
              required
              className={classes.fieldEdit}
            />
            <DisabledInput
              resource={resource}
              source="address.city"
              validate={[required, maxLength(128)]}
              required
              className={classes.fieldEdit}
            />
            {/* Mirrors the main address country: it must keep the same validators, otherwise
                registering this field drops the required rule from address.countryCode. */}
            <DisabledInput
              resource={resource}
              source="address.countryCode"
              label="resources.business.fields.billingAddress.country"
              validate={[required, maxLength(2)]}
              required
              format={getCountryName}
              className={classes.fieldEdit}
              id="Selenium-Business-Edit-Address-useAsBillingAddress-Country-Input"
            />
            {isItaly && (
              <DisabledInput
                source="address.region"
                label="resources.business.fields.invoicingRegion"
                validate={[required, nonEmptyString, maxLength(64)]}
                className={classes.fieldEdit}
                required
                id="businessInvoicingAddress"
              />
            )}
          </React.Fragment>
        )
      }
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData }) =>
        !formData.useAsBillingAddress && (
          <React.Fragment>
            <TextInput
              resource={resource}
              source="billingAddress.streetName"
              validate={[required, maxLength(128)]}
              required
              className={classes.fieldEdit}
              id="Selenium-Business-Edit-Address-notUseAsBillingAddress-StreetName-Input"
            />
            <TextInput
              resource={resource}
              source="billingAddress.postalCode"
              validate={[required, maxLength(32)]}
              required
              className={classes.fieldEdit}
            />
            <TextInput
              resource={resource}
              source="billingAddress.city"
              validate={[required, maxLength(128)]}
              required
              className={classes.fieldEdit}
            />
            <AutocompleteInput
              resource={resource}
              source="billingAddress.countryCode"
              label="resources.business.fields.billingAddress.country"
              validate={[required, maxLength(2)]}
              choices={countryAlpha2List}
              className={classes.fieldEdit}
              autoComplete="nope"
              classes={{ suggestionsContainerOpen: classes.autoCompleteContainer }}
              options={{ required: true }}
              id="Selenium-Business-Edit-Address-notUseAsBillingAddress-Country-Input"
            />
            {isItaly && (
              <TextInput
                source="billingAddress.region"
                label="resources.business.fields.invoicingRegion"
                validate={[required, nonEmptyString, maxLength(64)]}
                className={classes.fieldEdit}
                required
                id="businessInvoicingAddress"
              />
            )}
          </React.Fragment>
        )
      }
    </FormDataConsumer>
  </SimpleShowLayout>
);

BusinessAddress.propTypes = {
  classes: PropTypes.shape({}),
  resource: PropTypes.string,
  isItaly: PropTypes.bool,
};
